export const extractAppURL = (hostname: string): string => {
  return hostname.split(".").slice(-2).join(".");
};
